import React, { useRef, useEffect, useState } from 'react';
import { useField } from '@unform/core';
import pt from './pt';
import { DateObject } from 'react-multi-date-picker';

import { Container, CalendarPicker, ErrorMessage, Info } from './styles';

interface IProps {
  name: string;
}

const CalendarDatePicker: React.FC<IProps> = ({ name }) => {
  const calendarRef = useRef<any>(null); // referenciar o componente CalendarPicker
  const { fieldName, registerField, defaultValue, error } = useField(name);

  const [selectedDates, setSelectedDates] = useState<DateObject[]>(
    defaultValue || [],
  );

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: calendarRef.current,
      getValue: () => {
        return selectedDates;
      },
      setValue: (_, value: DateObject[]) => {
        setSelectedDates(value || []);
      },
      clearValue: () => {
        setSelectedDates([]);
      },
    });
  }, [fieldName, registerField, selectedDates]);

  return (
    <Container>
      <CalendarPicker
        ref={calendarRef}
        numberOfMonths={2}
        multiple
        value={selectedDates}
        onChange={(dates: DateObject[]) => setSelectedDates(dates)}
        shadow={false}
        hideWeekDays={false}
        mapDays={({ date }) => {
          const props: any = { className: '' };
          const isWeekend = [0, 6].includes(date.weekDay.index);
          if (isWeekend) props.className = 'highlight highlight-red';
          return props;
        }}
        $error={error}
        locale={pt}
      />
      <Info>
        <ErrorMessage>{error}</ErrorMessage>
      </Info>
    </Container>
  );
};

export default CalendarDatePicker;
